const PANEL_FOOTER_JUSTIFY = ['start', 'center', 'end'];

export { PANEL_FOOTER_JUSTIFY };
